import BaseBlockMap from './BaseBlockMap';
import GicsBlockMap from './GicsBlockMap';


export default {
    ...BaseBlockMap,
    ...GicsBlockMap,
};
